import { Component, OnDestroy, OnInit } from '@angular/core'
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import config from 'devextreme/core/config'
import notify from 'devextreme/ui/notify'
import { Subject } from 'rxjs'
import { finalize, first } from 'rxjs/operators'
import { AuthenticationService } from 'src/app/core/authentication/authentication.service'
import { EncryptionService } from 'src/app/core/services/encryption.service'
import { licenseKey } from '../../../../../devextreme-license'

config({ licenseKey })

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  valForm: FormGroup
  loading = false
  isChangePassword = false
  passwordRules = ''

  private unsubscribe = new Subject<void>()

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private fb: FormBuilder,
    private encryptionService: EncryptionService
  ) {}

  onSubmit() {
    const confirmNewPassword = this.getControl('confirmNewPassword')
    confirmNewPassword.updateValueAndValidity()

    if (!this.valForm.valid) {
      Object.keys(this.valForm.controls).forEach((field) => {
        const formControl = this.valForm.controls[field]
        formControl.markAsTouched({ onlySelf: true })
      })
      return
    }
    this.loading = true
    const encodedUsername = this.encryptionService.encrypt(this.valForm.value.username)
    const encodedPassword = this.encryptionService.encrypt(this.valForm.value.password)
    const encodedNewPassword = this.encryptionService.encrypt(this.valForm.value.newPassword)
    const encodedConfirmedPassword = this.encryptionService.encrypt(
      this.valForm.value.confirmNewPassword
    )
    this.authenticationService
      .login(encodedUsername, encodedPassword, encodedNewPassword, encodedConfirmedPassword)
      .pipe(
        first(),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        (response) => {
          if (response.passwordExpired) {
            this.isChangePassword = true
            this.passwordRules = response.passwordRules
          } else {
            this.router.navigate(['home'], { replaceUrl: true })
            if (response.mustNotifyUser) {
              const message = 'Ο κωδικός λήγει σε ' + response.expirationDays + ' ημέρες!'
              notify(message, 'warning', 5000)
            }
          }
          if (response.mustNotifyUser) {
            const message = 'Ο κωδικός λήγει σε ' + response.expirationDays + ' ημέρες!'
            notify(message, 'warning', 5000)
          }
        },
        (response) => notify(response.error.message, 'error', 600)
      )
  }

  ngOnInit() {
    if (this.authenticationService.isAuthenticated()) {
      this.router.navigate(['home'])
    }
    this.valForm = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
      newPassword: [null],
      confirmNewPassword: [null, this.matchingPasswords()],
    })
  }

  matchingPasswords(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let isValid = false
      if (this.valForm == null) {
        return null
      }
      const password = this.getControl('newPassword')
      if (password.value === control.value) {
        isValid = true
      }
      return isValid
        ? null
        : {
            matchingPasswords: true,
          }
    }
  }
  getControl(name: string) {
    return this.valForm.get(name)
  }

  ngOnDestroy() {
    this.unsubscribe.next()
    this.unsubscribe.complete()
  }
}
